import { Modal, message, ConfigProvider } from 'antd';
import axios from 'axios';

export function SaveDialog({ open, onOpenChange, data, onSuccess }) {
  async function saveEmployeeData() {
    try {
      const response = await axios.post(
        'https://radar.tlpservicos.com.br/api/veiculos/transferir-condutor',
        data
      );

      message.success('Condutor alterado com sucesso!');

      onOpenChange(false);

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error('Error:', err);
      message.error('Erro ao alterar condutor. Tente novamente.');
    }
  }

  const handleCancel = () => {
    onOpenChange(false);
  };

  const theme = {
    token: {
      colorBgElevated: '#333',
      colorText: '#fff',
      colorTextHeading: '#fff',
    },
    components: {
      Button: {
        colorBgContainer: 'transparent',
      },
    },
  };

  return (
    <ConfigProvider theme={theme}>
      <Modal
        title="Salvar alteração"
        open={open}
        onOk={saveEmployeeData}
        onCancel={handleCancel}
        okText="Salvar"
        cancelText="Cancelar"
      >
        Confirma a mudança de condutor para este veículo?
      </Modal>
    </ConfigProvider>
  );
}
